import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash (like #oem, #smb), don't scroll to top immediately
    // Let the page handle the hash navigation first
    if (hash) {
      // Small delay to let the page load, then handle hash navigation
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          // If hash element not found, scroll to top
          window.scrollTo(0, 0);
        }
      }, 100);
    } else {
      // No hash, scroll to top immediately
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;